import { ptToVwConverter, mobileVwConverter } from "../../utils";
import styled from "styled-components";
import { Grid, Button } from "@material-ui/core";

// list page

export const PerformancesContainer = styled.div`
  height: 100%;
  min-height: 100%;
  margin-top: ${ptToVwConverter(116)}vw;
  margin-left: ${ptToVwConverter(200)}vw;
  margin-right: ${ptToVwConverter(200)}vw;
  padding: 0;
  @media (max-width: 1024px) {
    height: auto;
    margin: ${mobileVwConverter(120)}vw ${mobileVwConverter(50)}vw 0
      ${mobileVwConverter(50)}vw;
  }
`;

// it needs to be something other than div to trigger rendering
export const PerformancesMain = styled.main`
  height: auto;
  width: ${ptToVwConverter(890)}vw;
  margin-left: ${ptToVwConverter(60)}vw;
  @media (max-width: 1024px) {
    width: 100%;
    margin-left: 0;
    margin-top: ${mobileVwConverter(60)}vw;
  }
`;

export const CategoryWrapper = styled.div`
  min-height: 300px;
  margin-left: ${ptToVwConverter(26)}vw;
  padding-bottom: ${ptToVwConverter(80)}vw;
  @media (max-width: 1024px) {
    margin-left: 0;
    padding-bottom: ${mobileVwConverter(100)}vw;
  }
`;

export const CategoryTitle = styled.div`
  display: grid;
  margin-bottom: 20px;
  width: 220px;
  height: 35px;
  text-align: center;
  align-items: center;
  background-color: black;
  color: white;
  letter-spacing: 0.1rem;
  @media (max-width: 1024px) {
    width: 100%;
    height: 30px;
    margin-bottom: 0;
    font-size: 14px;
  }
`;

export const CategoryGrid = styled(Grid)`
  && {
    width: ${ptToVwConverter(830)}vw;
    height: auto;
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
`;

export const CategoryItem = styled(Grid)`
  && {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
`;

export const LinkButton = styled(Button)`
  && {
    margin-bottom: ${ptToVwConverter(40)}vw;
    margin-right: ${ptToVwConverter(20)}vw;
    padding: 0;
    display: block;
    text-align: left;
    line-height: unset;
    text-transform: unset;
    border-radius: 0;
    height: fit-content;

    @media (max-width: 1024px) {
      width: 100%;
      margin-top: ${mobileVwConverter(40)}vw;
      margin-bottom: 0;
      margin-right: 0;
    }
  }
`;

export const PerformancePhoto = styled.img`
  border: solid 1px #d4d4d4;
  width: ${ptToVwConverter(270)}vw;
  height: ${ptToVwConverter(180)}vw;
  margin-bottom: ${ptToVwConverter(20)}vw;

  @media (max-width: 1024px) {
    width: 100%;
    height: auto;
  }
`;
// min-height: ${mobileVwConverter(200)}vw;
// width: ${mobileVwConverter(300)}vw;
// height: ${mobileVwConverter(200)}vw;

export const PerformancePhotoAlt = styled.div`
  border: solid 1px #d4d4d4;
  width: ${ptToVwConverter(270)}vw;
  height: ${ptToVwConverter(180)}vw;
  margin-bottom: ${ptToVwConverter(20)}vw;

  @media (max-width: 1024px) {
    width: 100%;
    height: ${mobileVwConverter(200)}vw;
  }
`;

export const PerformanceTitle = styled.div`
  letter-spacing: 0.1em;
  color: black;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: ${ptToVwConverter(6)}vw;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(13)}vw;
    font-size: 12px;
  }
`;

export const PerformanceText = styled.div`
  font-size: 12px;
  letter-spacing: 0.1em;
  color: #808080;
  margin-bottom: ${ptToVwConverter(2)}vw;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(2)}vw;
  }
`;

// list page (workshop)

export const WorkshopIntro = styled.div`
  margin-top: 2em;
  margin-left: ${ptToVwConverter(26)}vw;
  margin-bottom: 2em;
  width: ${ptToVwConverter(830)}vw;
  color: #4d4d4d;
  line-height: 3em;
  font-size: 14px;
  letter-spacing: 0.1rem;
  padding-right: 35px;
  @media (max-width: 1024px) {
    width: 100%;
    margin-left: 0;
    padding: 0;
  }
`;

// id page

export const RightContainer = styled.main`
  height: auto;
  width: 100%;
  display: block;
  margin-left: ${ptToVwConverter(26)}vw;
  min-height: 545px;
  @media (max-width: 1024px) {
    margin-left: 0;
    margin-top: ${mobileVwConverter(60)}vw;
  }
`;

export const Title = styled.div`
  margin-bottom: ${ptToVwConverter(14)}vw;
  color: black;
  font-size: 20px;
  letter-spacing: 0.1em;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(30)}vw;
  }
`;

export const SubTitle = styled.div`
  margin-bottom: ${ptToVwConverter(2)}vw;
  color: #808080;
  font-size: 14px;
  letter-spacing: 0.1em;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(5)}vw;
  }
`;

export const VideoWrapper = styled.div`
  height: ${ptToVwConverter(560)}vw;
  @media (max-width: 1024px) {
    width: 100%;
    height: ${mobileVwConverter(360)}vw;
    margin-top: ${mobileVwConverter(70)}vw;
  }
`;

export const BodyWrapper = styled.div`
  margin-bottom: ${ptToVwConverter(40)}vw;
  color: #4d4d4d;
  font-size: 14px;
  letter-spacing: 0.1rem;
  line-height: 2.8em;
  margin-top: ${ptToVwConverter(30)}vw;
  @media (max-width: 1024px) {
    margin-top: ${mobileVwConverter(60)}vw;
    margin-bottom: ${mobileVwConverter(50)}vw;
    letter-spacing: 0.05rem;
  }
`;

export const InfoWrapper = styled.div`
  margin-bottom: ${ptToVwConverter(40)}vw;
  color: #4d4d4d;
  font-size: 14px;
  letter-spacing: 0.1rem;
  line-height: 2.8em;
  margin-top: ${ptToVwConverter(30)}vw;
  @media (max-width: 1024px) {
    margin-top: ${mobileVwConverter(60)}vw;
    letter-spacing: 0.05rem;
    line-height: 2.4em;
    font-size: 12px;
  }
`;

export const FlyerButton = styled(Button)`
  && {
    border: solid 3px black;
    border-radius: 0;
    width: 200px;
    height: 50px;
    letter-spacing: 0.1rem;
    font-size: 12px;
    margin-bottom: ${ptToVwConverter(30)}vw;
    @media (max-width: 1024px) {
      width: 180px;
      height: 60px;
      margin-top: ${mobileVwConverter(30)}vw;
      margin-bottom: ${mobileVwConverter(80)}vw;
    }
  }
`;

export const LogoImage = styled.img`
  width: ${ptToVwConverter(261)}vw;
  height: ${ptToVwConverter(174)}vw;
  margin-right: ${ptToVwConverter(11.5)}vw;
  object-fit: contain;
  border: solid 1px #d4d4d4;
  @media (max-width: 1024px) {
    margin-right: ${mobileVwConverter(11.5)}vw;
    width: ${mobileVwConverter(315)}vw;
    height: ${mobileVwConverter(210)}vw;
  }
`;
